// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35ROL","toggle":"styles_toggle__1toQW","preview":"styles_preview__1EXT4"};